import React from "react";

function SalonGridLoading(props) {
  const { children } = props;

  return <>{children}</>;
}

export default SalonGridLoading;
